
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import SwiperCore from 'swiper';
SwiperCore.use([Autoplay]);



const clientLogos = [
  { src: '/assets/images/clients/99Estimators.png', alt: '99Estimators' },
  { src: '/assets/images/clients/aiprognoza-logo.png', alt: 'Aiprognoza' },
  { src: '/assets/images/clients/Fitnessfirst-logo.png', alt: 'Fitnessfirst' },
  { src: '/assets/images/clients/HBS-logo.png', alt: 'HBS' },
  { src: '/assets/images/clients/HealthYoga-logo.png', alt: 'HealthYoga' },
  { src: '/assets/images/clients/revex_remove.png', alt: 'Revex' },
  { src: '/assets/images/clients/SiteMaker-Logo.png', alt: 'SiteMaker' },
  { src: '/assets/images/clients/Voiceboost ai logo.png', alt: 'Voiceboost AI' },
  { src: '/assets/images/clients/wecodes-logo.png', alt: 'Wecodes' },
  { src: '/assets/images/clients/99Estimators.png', alt: '99Estimators' },
  { src: '/assets/images/clients/aiprognoza-logo.png', alt: 'Aiprognoza' },
  { src: '/assets/images/clients/Fitnessfirst-logo.png', alt: 'Fitnessfirst' },
  { src: '/assets/images/clients/HBS-logo.png', alt: 'HBS' },
  { src: '/assets/images/clients/HealthYoga-logo.png', alt: 'HealthYoga' },
  { src: '/assets/images/clients/revex_remove.png', alt: 'Revex ' },
  { src: '/assets/images/clients/SiteMaker-Logo.png', alt: 'SiteMaker' },
  { src: '/assets/images/clients/Voiceboost ai logo.png', alt: 'Voiceboost AI' },
  { src: '/assets/images/clients/wecodes-logo.png', alt: 'Wecodes' },
];

const Clientlogos = () => {
  return (
    <section className="client_logo_section section_space">
      <div className="container">
        <div className="section_space pt-0">
          <div className="heading_block text-center">
            <div className="heading_focus_text mb-0">
              <span className="badge bg-secondary text-white">Brand We</span>
              Work With
            </div>
          </div>
          <div className="client_logo_carousel">
            <Swiper
              spaceBetween={30}
              slidesPerView={7}
              loop={true}
              speed={1500}
              autoplay={{
                delay: 1,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }}
              breakpoints={{
                320: { slidesPerView: 2 },
                640: { slidesPerView: 3 },
                1024: { slidesPerView: 5 }
              }}
              allowTouchMove={false}
            >
              {clientLogos.filter(logo => logo && logo.src).map((logo, idx) => (
                <SwiperSlide key={idx}>
                  <div className="client_logo_item">
                    <img
                      src={logo.src}
                      loading="lazy"
                      alt={logo.alt ? `${logo.alt} - Client Logo Image` : 'Client Logo'}
                      onError={e => { e.target.onerror = null; e.target.src = '/assets/images/clients/default-logo.png'; }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clientlogos;